import React from "react";
import styles from "./ProblemSolutionSection.module.css";
import solutionImage from "../../../Images/zvs77wxs.png";
import { AlertCircle, CheckCircle2, Brain } from "lucide-react";

const ProblemSolutionSection = () => {
    return (
        <section className={styles.section}>
            {/* PROBLEM */}
            <div className={styles.problem}>
                <h2 className={styles.title}>The Problem</h2>

                <div className={styles.cards}>
                    <div className={styles.card}>
                        <AlertCircle className={styles.alertIcon} />
                        <p>You’re still typing what you already said.</p>
                    </div>

                    <div className={styles.card}>
                        <AlertCircle className={styles.alertIcon} />
                        <p>You’re still paying humans to do what ToxBox AI should handle.</p>
                    </div>

                    <div className={styles.card}>
                        <AlertCircle className={styles.alertIcon} />
                        <p>And most tools still fail the moment speech isn’t “perfect.”</p>
                    </div>
                </div>

                <p className={styles.problemFooter}>
                    That’s lost time, lost focus, and bad data.
                </p>
            </div>

            {/* SOLUTION */}
            <div className={styles.solution}>
                <div className={styles.solutionLeft}>
                    <h2 className={styles.solutionTitle}>THE SOLUTION</h2>

                    <h3 className={styles.solutionHeadline}>
                        ToxBox AI Speech to Text listens better than humans.
                    </h3>

                    <p className={styles.solutionDesc}>
                        Powered by advanced AI models trained on real-world speech —
                        accents, noise, speed changes included.
                    </p>

                    <ul className={styles.checkList}>
                        <li>
                            <CheckCircle2 /> You speak.
                        </li>
                        <li>
                            <CheckCircle2 /> We handle the rest.
                        </li>
                    </ul>

                    <div className={styles.featureBox}>
                        <Brain className={styles.brainIcon} />
                        <div>
                            <h4>Human-Like Expression, Not Flat Audio</h4>
                            <p>
                                From laughter and sighs to natural pauses and breath sounds,
                                ToxBox AI reproduces the non-verbal cues that make voices feel alive.
                            </p>
                        </div>
                    </div>
                </div>

                <div className={styles.solutionRight}>
                    <img
                        src={solutionImage}
                        alt="ToxBox AI Speech Visualization"
                        className={styles.solutionImage}
                    />
                </div>
            </div>
        </section>
    );
};

export default ProblemSolutionSection;